const flattenObject = (obj: any, prefix = '', res: any = {})=> {
    for (let key in obj) {
        let newKey = prefix ? `${prefix}.${key}` : key;
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            flattenObject(obj[key], newKey, res);
        } else {
            res[newKey] = obj[key];
        }
    }
    return res;
}

let translations: any = {};
let fallbackTranslations: any = {};

export const resolveUserLang = (): string => {
    let lang = window.navigator.languages ? window.navigator.languages[0] : null;
    lang = lang ?? window.navigator.language ?? (window.navigator as any).browserLanguage ?? (window.navigator as any).userLanguage;

    let shortLang = lang;
    if (shortLang.indexOf('-') !== -1) {
        shortLang = shortLang.split('-')[0];
    }

    if (shortLang.indexOf('_') !== -1) {
        shortLang = shortLang.split('_')[0];
    }

    console.log('User lang: ' + shortLang)
    return shortLang ?? 'en';
}

export const setLang = (lang: string|null = null)=> {
    if (!lang) {
        lang = resolveUserLang()
    }

    if (!['en'].includes(lang)) {
        lang = 'en';
    }

    const items = require(`@/i18n/${lang}.json`)
    const fallback = require(`@/i18n/en.json`)
    translations = flattenObject(items);
    fallbackTranslations = flattenObject(fallback);
    window.userLang = lang
}

export const $t = (key: string, params: any = {}, fallback: string|null = null) => {
    let msg = translations[key] ?? fallbackTranslations[key] ?? fallback ?? key;

    if (params) {
        for (let paramName in params) {
            msg = msg.replaceAll(`{${paramName}}`, params[paramName])
        }
    }

    return msg;
}